module.exports = __webpack_public_path__ + "img/b_logo.610c8dbd.png";